import SmallActionButton from '@components/UI/SmallActionButton';
import DataHandlerOptions from '@navigation/screens/MidLevel/DataScreen/components/DataHandler/DataHandlerOptions';
import { themeSelector } from '@reduxLocal/selectors/themeSelector';
import React, { useCallback, useContext, useState } from 'react';
import { Platform, View, Text } from 'react-native';
import * as Animatable from 'react-native-animatable';
import { Ionicons } from '@expo/vector-icons';
import AnimatedLottieView from '@utils/lottieAnimation';
import { FormikProps } from 'formik';
import AnimateTextEntry from '@hooks/animateTextEntry';
import LoadingIndicator from '@components/Global/Spinner';
import { useSelector, useDispatch } from 'react-redux';
import { DefaultRootState } from '@reduxLocal/persistState';
import stages from '../constants/stages';
import { Stepper, Step, StepLabel } from '@mui/material';
import { data } from 'jquery';
import parseSchema from '../utils/parseSchema';
import { AI_API_URL } from '@api/constant';
import { SizableText } from 'tamagui';
import { HIDE_ALL_MODALS, HIDE_LOADING_MODAL, SHOW_AUTH_MODAL, SHOW_LOADING_MODAL, CHANGE_DATA_TITLE, CHANGE_DATA_TAGS, REPLACE_HANDLER_SCHEMA } from '@reduxLocal/actions/types';
import { ToolbarContext } from '@hooks/toolbarContext';

const DataHandlerHeader = () => {
  const uploaderStage = useSelector((state: DefaultRootState) => state.UI.uploaderStage);
  const { ref, setRef, optionsRef, setOptionsRef } = useContext(ToolbarContext);
  const dataUp = useSelector((state: DefaultRootState) => state.uploadPreview?.present);
  
  // Get data from Redux for display and initial values
  const dataTitles = useSelector((state: DefaultRootState) => state.uploadPreview?.present?.dataTitle || "");
  const tags = useSelector((state: DefaultRootState) => state.uploadPreview?.present?.dataTags || []);
  const description = useSelector((state: DefaultRootState) => state.uploadPreview?.present?.description || "");
  
  const dispatch = useDispatch();
  const theme = themeSelector();
  const [showSettings, setShowSettings] = useState(true);
  const [loaded, setLoaded] = useState(false);
  const formRef = React.useRef<FormikProps<any>>(null);
  const [showAI, setShowAI] = useState(false);
  const [aiText, setAIText] = useState("");
  const [aiLoading, setAILoading] = useState(false);

  console.log("Mounted DataHandlerHeader", optionsRef?.current);
  console.log("Redux State - dataTitles:", dataTitles, "tags:", tags, "description:", description);

  const handleToggleSettings = useCallback(
    (value: boolean) => {
      setShowSettings(value);
    },
    []
  );


    const _checkForAISuggestions = useCallback(async () => {
      if (showSettings) {
        if (formRef.current) {
          //Validate form
          formRef.current?.validateForm().then(async (res) => {
            // Proceed with AI call if form is valid (no validation errors)
            if (!res || Object.keys(res).length === 0) {
              setAIText("Looking for suggestions");
              setAILoading(true);

              try {
                dispatch({ type: SHOW_LOADING_MODAL })
                const response = await fetch(`${AI_API_URL}/create-schema`, {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    // Optionally add 'mode: "no-cors"' if necessary, but this is usually not recommended unless you fully understand its implications.
                  },
                  body: JSON.stringify({
                    description: formRef.current?.values.description || description,
                    currentSchema: dataUp?.dataHeld,
                    tags: formRef.current?.values.tags || tags
                  }),
                })

                const data = await response.json();
                console.log(data, 'res from AI');
                console.log('API Request payload:', {
                  description: formRef.current?.values.description || description,
                  currentSchema: dataUp?.dataHeld,
                  tags: formRef.current?.values.tags || tags
                });
                if(data.error){
                  console.error('Error from AI:', data.error);
                  setAIText("Error fetching suggestions");
                  dispatch({ type: HIDE_LOADING_MODAL });
                  return;
                }
                parseSchema(data?.raw || data, dispatch);
                setAIText("Received suggestions");
                console.log(data, 'res from AI');

              } catch (err) {
                console.error('Error from AI:', err);
                setAIText("Error fetching suggestions");

              } finally {
                setAILoading(false);
                dispatch({ type: HIDE_LOADING_MODAL })
              }
            } else {
              setAIText("Please fill in all required fields before getting AI suggestions");
            }
          });

          //Proceed with API call using title and description
        }
        setShowAI(true)
      }
      else {
        setShowAI(false);
      }
    }, [showSettings, formRef, description, dataUp?.dataHeld, tags, dispatch]);

      const showErrorModal = (message) => {
        console.log('calling show error modal')
        dispatch({type: HIDE_ALL_MODALS});
        dispatch({ type: SHOW_AUTH_MODAL, data: { content: message } })
      }

    const actions = aiText === "Received suggestions" ? [
      {
        icon: aiLoading ? <LoadingIndicator type={'processing'} color={'rgb(90,192,234)'} /> : <AnimatedLottieView source={require('@assets/animations/automation_robot.json')} autoPlay loop={false} style={{ minWidth: 40, maxWidth: 40, margin: -8 }} />,
        function: () => { _checkForAISuggestions() },
        hint: "Run automation",
        label: "Run AI",
        row: true,
        labelColor: theme ? "black" : "white",
      },
      {
        icon: <Ionicons name="refresh" size={24} color="black" />,
        function: () => { _checkForAISuggestions() },
        hint: "Refresh suggestions",
        label: "Refresh AI",
        row: true,
        labelColor: theme ? "black" : "white",
      },
      {
        icon: <Ionicons name="settings" size={24} color="black" />,
        function: () => { handleToggleSettings(!showSettings); if (showSettings) setShowAI(false) },
        hint: "Model settings",
        row: true,
        labelColor: theme ? "black" : "white",
      },
      {
        icon: <Ionicons name="save" size={24} color="black" />,
        function: async () => {
          dispatch({ type: SHOW_LOADING_MODAL })
          if (optionsRef?.current) {
            await optionsRef?.current?.validateForm?.().then(async (r) => {
              if (r && r.content) {
                dispatch({ type: HIDE_ALL_MODALS });
                showErrorModal('Please fill in all required fields')
              }
              else if (!r || !r.content) {
                await optionsRef?.current?.handleSubmit?.()
              }
            }).catch((e) => {
              console.error('error', e);
              dispatch({ type: HIDE_ALL_MODALS });
              showErrorModal('Please fill in all required fields')
            });
          } else {
            console.error("Options ref not found");
            dispatch({ type: HIDE_ALL_MODALS });
          }
        },
        hint: "Save changes",
        label: "Save",
        row: true,
        labelColor: theme ? "black" : "white",
      }
    ] : [
      {
        icon: <AnimatedLottieView source={require('@assets/animations/automation_robot.json')} autoPlay loop={false} style={{ width: 40, height: 40, margin: -8 }} />,
        function: () => { _checkForAISuggestions() },
        hint: "Run automation",
        label: "AI",
        row: true,
        labelColor: theme ? "black" : "white",
      },
      {
        icon: <Ionicons name="settings" size={30} color="black" />,
        function: () => { handleToggleSettings(!showSettings); if (showSettings) setShowAI(false) },
        hint: "Model settings",
        label: "Toggle Settings",
        row: true,
        labelColor: theme ? "black" : "white",
      },
        {
          icon: <Ionicons name="save" size={24} color="black" />,
          function: async () => {
            dispatch({ type: SHOW_LOADING_MODAL })
            console.log('calling save', optionsRef)
            if (optionsRef?.current) {
              console.log('found options ref');
              await optionsRef?.current?.validateForm?.().then(async (r) => {
                if (r && r.content) {
                  dispatch({ type: HIDE_ALL_MODALS });
                  showErrorModal('Please fill in all required fields')
                }
                else if (!r || !r.content) {
                  await optionsRef?.current?.handleSubmit?.()
                }
              }).catch((e) => {
                console.error('error', e);
                dispatch({ type: HIDE_ALL_MODALS });
                showErrorModal('Please fill in all required fields')
              });
            } else {
              console.error("Options ref not found");
              dispatch({ type: HIDE_ALL_MODALS });
            }
          },
          hint: "Save changes",
          label: "Save",
          row: true,
          labelColor: theme ? "black" : "white",
        }
      ]

    return (
      <Animatable.View
        transition={["maxHeight", "height"]}
        style={[
          {
            height: showSettings ? 400 : 80,
            shadowRadius: 20,
            maxHeight: showSettings ? 400 : 80,
            shadowOpacity: 0.15,
            shadowColor: '#000',
            shadowOffset: { width: 0, height: 4 },
            flexDirection: 'column' as const,
            borderBottomStartRadius: 24,
            borderBottomEndRadius: 24,
            top: Platform.OS !== 'web' ? 7 : undefined,
            justifyContent: 'space-between' as const,
            alignItems: 'center' as const,
            padding: showSettings ? 20 : 16,
            paddingBottom: showSettings ? 10 : 16,
            backgroundColor: theme ? "white" : "#1a1a1a",
            borderWidth: 1,
            borderColor: theme ? "rgba(0,0,0,0.1)" : "rgba(255,255,255,0.1)",
            overflow: 'hidden',
          },
          Platform.OS === 'web' && {
            marginLeft: "6vw" as any,
            marginHorizontal: "5vw" as any,
            transition: 'height 0.4s cubic-bezier(0.4,0,0.2,1), max-height 0.4s cubic-bezier(0.4,0,0.2,1), background-color 0.3s ease, padding 0.3s ease',
            willChange: 'height, max-height, background-color, padding',
            maxWidth: '1200px',
            alignSelf: 'center',
            width: '90%',
          } as any
        ]}
      >
        {
          uploaderStage > 0 && dataUp?.isUpload &&
          <View style={{ maxHeight: 20, gap: 100, flex: 1, flexDirection: "row" }}>
            <Text>Records: {dataUp?.dataLength}</Text>
            <Stepper activeStep={2}>
              {
                stages.map((stage, index) => {
                  return (
                    <Step key={index}>
                      <StepLabel style={{ userSelect: "none", fontSize: showSettings ? undefined : 0, color: showSettings ? undefined : 'transparent' }}>{stage.title}</StepLabel>
                    </Step>
                  )
                })
              }
            </Stepper>
          </View>
        }
        <Animatable.View 
          useNativeDriver={false}
          animation={showSettings ? 'fadeInDown' : 'fadeOutUp'} 
          duration={showSettings ? 400 : 300}
          style={{ 
            flex: showSettings ? 1.5 : 0,
            height: showSettings ? 'auto' : 0,
            flexDirection: 'row', 
            alignSelf: "stretch", 
            gap: 10, 
            marginBottom: showSettings ? 50 : 0,
            opacity: showSettings ? 1 : 0,
            overflow: 'hidden',
            borderRadius: showSettings ? 12 : 0,
            marginHorizontal: showSettings ? 8 : 0,
          }}
        >
          <DataHandlerOptions 
            ref={formRef} 
            tags={tags} 
            setTags={() => { }} 
            dataTitles={dataTitles} 
            setDataTitles={() => { }} 
            description={description} 
            setDescription={() => { }} 
          />
        </Animatable.View>
        <View style={{ 
          flexDirection: 'row', 
          alignSelf: "stretch", 
          minHeight: 48, 
          maxHeight: 48,
          position: "absolute", 
          bottom: 0, 
          left: 0,
          right: 0,
          justifyContent: 'space-between', 
          alignItems: 'center',
          paddingHorizontal: 24,
          paddingVertical: 12,
          backgroundColor: theme ? "white" : "#1a1a1a",
          borderTopWidth: showSettings ? 1 : 0,
          borderTopColor: theme ? "rgba(0,0,0,0.1)" : "rgba(255,255,255,0.1)",
        }}>
          <SizableText 
            numberOfLines={1} 
            style={{ 
              flex: 1, 
              fontWeight: 'bold',
              fontSize: 16,
              color: theme ? "#1a1a1a" : "#ffffff",
              marginRight: 16
            }}
            ellipsizeMode="tail"
          >
            {dataTitles || "Untitled Dataset"}
          </SizableText>
          <View style={{ 
            flexDirection: "row", 
            alignItems: "center",
            minHeight: 32,
            minWidth:250
          }}>
            {
              aiLoading ?
                <LoadingIndicator type={'processing'} color={'rgb(59, 130, 246)'} />
                :
                <View style={{
                  flexDirection: 'row',
                  backgroundColor: theme ? '#f0f0f0' : '#333',
                  borderRadius: 12,
                  padding: 3,
                  gap: 2,
                  transform: [{ scale: 0.8 }]
                }}>
                  {actions.map((action, index) => {
                    return (
                      <SmallActionButton
                        key={`action-${index}`}
                        action={action}
                        index={index}
                        noBorder
                        showLabel={true}
                        labelOrientation="inline"
                        removeWidthConstraint
                        color={theme ? '#1a1a1a' : '#ffffff'}
                      />
                    )
                  })}
                </View>
            }
          </View>
        </View>
      </Animatable.View>
    )
  }

export default DataHandlerHeader;